import React from 'react';

import Layout from '../components/Layout';

class KeysLost extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Report Keys Lost</h1>
            </Layout>
        );
    }
}

export default KeysLost;